const state = {
  options: {},
  s_customer: '',
  s_slip_no: '',
  s_item_name: '',
  s_type: 'slip_no'
}

const mutations = {
  SET_OPTIONS: (state, data) => {
    state.options = data
  },
  SET_SCOUSTOMER: (state, data) => {
    state.s_customer = data
  },
  SET_SSLIP_NO: (state, data) => {
    state.s_slip_no = data
  },
  SET_SITEM_NAME: (state, data) => {
    state.s_item_name = data
  },
  SET_STYPE: (state, data) => {
    state.s_type = data
  }
}

const actions = {
  // setOptions({ commit }, payload) {
  //   commit('SET_OPTIONS', payload)
  // },
  // setSearch({ commit }, payload) {
  //   commit('SET_SEARCH', payload)
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
